import ApiService from './ApiService';

export default {
  /**
   * Finds a size map by ID
   * @param {number} id Size Map ID
   * @returns {Promise<any>}
   */
  findById(id) {
    return new Promise((resolve, reject) => {
      const data = {
        id,
      };
      ApiService.request('GET', 'sizes/maps', data).then((response) => {
        if (response.status === 200 && response.data.length === 1) {
          resolve(response.data[0]);
        } else {
          reject(new Error());
        }
      }).catch(() => {
        reject(new Error());
      });
    });
  },
  /**
   * Creates a new size map
   * @param {array} data Data
   * @returns {Promise<any>}
   */
  create(data) {
    return new Promise((resolve, reject) => {
      ApiService.request('POST', 'sizes/maps', data).then((response) => {
        if (response.status === 201) {
          resolve(response.data);
        } else {
          reject(new Error());
        }
      }).catch(error => {
        reject(error);
      });
    });
  },
  /**
   * Updates a size map
   * @param {number} id Size Map ID
   * @param {array} data Data
   * @returns {Promise<any>}
   */
  update(id, data) {
    return new Promise((resolve, reject) => {
      ApiService.request('PUT', `sizes/maps/${id}`, data).then((response) => {
        if (response.status === 200) {
          resolve(response.data);
        } else {
          reject(new Error());
        }
      }).catch(() => {
        reject(new Error());
      });
    });
  },
  /**
   * Remove a size map by ID
   * @param {number} id Size Map ID
   * @returns {Promise<any>}
   */
  remove(id) {
    return new Promise((resolve, reject) => {
      ApiService.request('DELETE', `sizes/maps/${id}`, {}).then((response) => {
        resolve(response.data);
      }).catch(() => {
        reject(new Error());
      });
    });
  },
};
